import { WritableSignal } from "@angular/core";
import { Tag } from "@models/common/tag";
import { FilterOption } from "@models/grid/grid-filter";
import { ColDef, GridApi } from "ag-grid-community";

export function applyTagGridFilterOption(tag: Tag, colDefsSignal: WritableSignal<ColDef[]>, gridApi: GridApi, tagsField = 'tags'): void {
  const colDefs = colDefsSignal();
  const field = tag.isSystemTag ? 'systemTags' : tagsField;
  const relatedColumnIndex = colDefs.findIndex(c => c.field === field);
  if (!(relatedColumnIndex >= 0)) return;

  const filterOptions = (colDefs[relatedColumnIndex]?.filterParams as {
    filterOptions?: FilterOption[]
  })?.filterOptions ?? [];
  const filterModel = gridApi.getFilterModel();
  const tagName = tag.name;

  if (field in filterModel) {
    // filter model have filters for "field"
    const values = filterModel[field].values as string[];
    const isTagAlreadySelected = values.includes(tag.name);

    if (isTagAlreadySelected) {
      // exclude tag name for filter
      filterModel[field].values = values.filter((t) => t != tagName);

      if (!filterModel[field].values.length) {
        delete filterModel[field];
      }
    } else {
      // add tag name for filter
      (filterModel[field].values as string[]).push(tag.name);
    }

    filterOptions.forEach((option) => {
      if (option.value == tagName) {
        option.active = !isTagAlreadySelected;
      }
    });
  } else {
    // filter model does not have filters for "field"
    filterModel[field] = {
      filterType: "set",
      values: [tag.name]
    };

    if (filterOptions.length) {
      filterOptions.forEach((option) => {
        option.active = option.value === tagName;
      });
    }
  }

  colDefs[relatedColumnIndex]['filterTagShowed'] = Boolean(filterModel[field]);
  colDefsSignal.set(colDefs);
  gridApi.setFilterModel(filterModel);
}
